module.exports = __webpack_public_path__ + "assets/cpanel.83706621.svg";